import { XML_AddLinkToPDF } from "./XML_AddLinkToPDF";
import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";

export function XML_DrawSmallSubchartArrowPDF(
  x0,
  y0,
  x1,
  y1,
  x2,
  y2,
  drawElement,
  linkBookmark,
  layer,
  style
) {
  if (!drawElement.fIncludeSCArrows || linkBookmark == null) return;

  x0 = XML_ScaleAndShiftX(x0, drawElement, layer);
  y0 = XML_ScaleAndShiftY(y0, drawElement, layer);
  x1 = XML_ScaleAndShiftX(x1, drawElement, layer);
  y1 = XML_ScaleAndShiftY(y1, drawElement, layer);
  x2 = XML_ScaleAndShiftX(x2, drawElement, layer);
  y2 = XML_ScaleAndShiftY(y2, drawElement, layer);

  y0 = drawElement.ConvertY(y0);
  y1 = drawElement.ConvertY(y1);
  y2 = drawElement.ConvertY(y2);

  //var s = drawElement.GetStream();
  drawElement.DrawSmallArrow(x0, y0, x1, y1, x2, y2, style);

  XML_AddLinkToPDF(x0, y0, x1, y1, x2, y2, x2, x2, drawElement, linkBookmark);
}
